/* eslint-disable import/no-unresolved */
import React from 'react';

import mobileSVG from 'assets/resources/icon/mobile.svg';
import frontendSVG from 'assets/resources/icon/frontend.svg';
import backendSVG from 'assets/resources/icon/backend.svg';
import devopsSVG from 'assets/resources/icon/devops.svg';
import ImgHTML from '../../../ImgHTML';

const CustomSoftwareIcons = () => {
  return (
    <div className="icon-presentation">
      <div className="subtitle-simple">Areas of work</div>
      <div className="row">
        <div className="col-md-3">
          <div className="single">
            <div className="icon">
              <ImgHTML src={mobileSVG} alt="mobile icon" title="mobile icon" />
            </div>
            <div className="name">Mobile</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="single">
            <div className="icon">
              <ImgHTML
                src={frontendSVG}
                alt="frontend icon"
                title="frontend icon"
              />
            </div>
            <div className="name">Frontend</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="single">
            <div className="icon">
              <ImgHTML
                src={backendSVG}
                alt="backend icon"
                title="backend icon"
              />
            </div>
            <div className="name">Backend</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="single">
            <div className="icon">
              <ImgHTML src={devopsSVG} alt="devops icon" title="devops icon" />
            </div>
            <div className="name">DevOps</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSoftwareIcons;
